function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M20 10c0 5.519-4.481 10-10 10S0 15.519 0 10h20z",
  fill: "#ffd500",
  fillRule: "nonzero"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M10.065 0C15.554.035 20 4.502 20 10H0C0 5.502 2.969 1.698 7.055.441a9.993 9.993 0 00-4.126 2.488A9.968 9.968 0 000 10C0 4.481 4.481 0 10 0h-.065.13z",
  fill: "#005bbb",
  fillRule: "nonzero"
});

function SvgUa(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    fillRule: "evenodd",
    clipRule: "evenodd",
    strokeLinejoin: "round",
    strokeMiterlimit: 2
  }, props), _ref, _ref2);
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyMCAyMCIgc3R5bGU9ImZpbGwtcnVsZTpldmVub2RkO2NsaXAtcnVsZTpldmVub2RkO3N0cm9rZS1saW5lam9pbjpyb3VuZDtzdHJva2UtbWl0ZXJsaW1pdDoyOyI+DQogICAgPGcgdHJhbnNmb3JtPSJtYXRyaXgoLTEsLTEuMjI0NjVlLTE2LDEuMjI0NjVlLTE2LC0xLDIwLDIwKSI+DQogICAgICAgIDxwYXRoIGQ9Ik0wLDEwQzAsNC40ODEgNC40ODEsLTAgMTAsMEMxNS41MTksMCAyMCw0LjQ4MSAyMCwxMEwwLDEwWiIgc3R5bGU9ImZpbGw6cmdiKDI1NSwyMTMsMCk7ZmlsbC1ydWxlOm5vbnplcm87Ii8+DQogICAgPC9nPg0KICAgIDxnIHRyYW5zZm9ybT0ibWF0cml4KC0xLC0xLjIyNDY1ZS0xNiwxLjIyNDY1ZS0xNiwtMSwyMCwyMCkiPg0KICAgICAgICA8cGF0aCBkPSJNOS45MzUsMjBDNC40NDYsMTkuOTY1IDAsMTUuNDk4IDAsMTBMMjAsMTBDMjAsMTQuNDk4IDE3LjAzMSwxOC4zMDIgMTIuOTQ1LDE5LjU1OUMxNC41MjIsMTkuMDc0IDE1LjkzMywxOC4yMDkgMTcuMDcxLDE3LjA3MUMxOC44ODEsMTUuMjYxIDIwLDEyLjc2MSAyMCwxMEMyMCwxNS41MTkgMTUuNTE5LDIwIDEwLDIwTDEwLjA2NSwyMEw5LjkzNSwyMFoiIHN0eWxlPSJmaWxsOnJnYigwLDkxLDE4Nyk7ZmlsbC1ydWxlOm5vbnplcm87Ii8+DQogICAgPC9nPg0KPC9zdmc+DQo=";
export { SvgUa as ReactComponent };